import { render } from "./CusRadio.vue?vue&type=template&id=3a64fc96&scoped=true"
import script from "./CusRadio.vue?vue&type=script&lang=js"
export * from "./CusRadio.vue?vue&type=script&lang=js"

import "./CusRadio.vue?vue&type=style&index=0&id=3a64fc96&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a64fc96"]])

export default __exports__